import React from "react";
import { useTranslation } from "react-i18next";

// Sample array of card data stored in JSON format
const cardsData = [
  {
    titleKey: "customer_ideas_title",
    descriptionKey: "customer_ideas_description",
    image: "/assets/images/img_05.jpg",
    imagePosition: "left", // Can be 'left' or 'right'
  },
  {
    titleKey: "design_concepts_title",
    descriptionKey: "design_concepts_description",
    image: "/assets/images/img_02.jpeg",
    imagePosition: "right", // Can be 'left' or 'right'
  },
  {
    titleKey: "expert_guidance_title",
    descriptionKey: "expert_guidance_description",
    image: "/assets/images/section03_04.jpg",
    imagePosition: "left", // Can be 'left' or 'right'
  },
];

const DiamondCard = ({ data }) => {
  const { t } = useTranslation("cards"); // Namespace for translations

  // Determine the layout based on imagePosition
  const isImageLeft = data.imagePosition === "left";

  return (
    <div
      className="max-w-6xl mx-auto p-6 mb-1 rounded-md flex flex-col md:flex-row md:gap-6 gap-0"
      data-aos="fade-up"
      data-aos-duration="1000"
    >
      {/* Image Section */}
      <div
        className={`w-full md:w-1/2 shadow-md rounded-md ${
          isImageLeft ? "md:order-1" : "md:order-2"
        }`}
      >
        <img
          src={data.image}
          alt={t(data.titleKey)} // Alt text based on the title
          className="object-cover w-full h-auto md:h-64 rounded-md shadow-md"
          style={{ maxWidth: "100%" }} // Ensures the image remains responsive
        />
      </div>

      {/* Text Section */}
      <div
        className={`w-full md:w-1/2 p-6 bg-white shadow-md rounded-md ${
          isImageLeft ? "md:order-2" : "md:order-1"
        }`}
      >
        <h2 className="text-3xl font-bold text-primary mb-4">
          {t(data.titleKey)}
        </h2>
        <p className="text-secondary">{t(data.descriptionKey)}</p>
      </div>
    </div>
  );
};

const Card = () => {
  return (
    <div className="flex flex-col gap-0 md:gap-6">
      {/* Map over the cardsData array to render multiple DiamondCard components */}
      {cardsData.map((card, index) => (
        <DiamondCard key={index} data={card} />
      ))}
    </div>
  );
};

export default Card;
